import React from 'react';

import styled, { css } from 'styled-components';

import { ProductCategoryTree as BaseProductCategoryTree } from '@techstyle/react-components';

const CategoryTree = styled(BaseProductCategoryTree)`
  font-size: 14px;
  line-height: 2.86;
  letter-spacing: ${0.3 / 14}em;
  color: ${props => props.theme.colors.default};
  padding-bottom: ${({ theme }) => theme.spacing.medium}px;
`;

const getActiveCategoryStyle = props => {
  if (props.isActive) {
    return css`
      border-bottom: 2px solid ${props => props.theme.colors.lavender};

      &:hover {
        color: ${props => props.theme.colors.black};
        border-bottom: 2px solid ${props => props.theme.colors.lavender};
      }
    `;
  }
  return css`
    color: inherit;
  `;
};

const categoryListStyle = css`
  &&& {
    padding-top: 0;
  }
  & & {
    padding-left: 0;
  }

  & & & {
    padding-left: ${({ theme }) => theme.spacing.small}px;
  }
  line-height: 2.86;
`;

const categoryLinkStyle = css`
  ${({ theme }) => theme.links.variants.navigationPrimary}

  ${getActiveCategoryStyle};
  line-height: normal;
  letter-spacing: normal;
`;

const categoryItemStyle = css`
  padding: 0;
`;

function ProductCategoryTree(props) {
  return (
    <CategoryTree
      activeCategoryChecker={category => category.urlPath}
      categoryListStyle={categoryListStyle}
      categoryLinkStyle={categoryLinkStyle}
      categoryItemStyle={categoryItemStyle}
      hideFilterableCategories={false}
      {...props}
    />
  );
}

export default ProductCategoryTree;
